<template>
       <Tabs v-model="defaultIndex" @on-click="handleTabClick">
          <TabPane label="采集配置" name="server">
            <ServerList ref="serverList"  @onBactchOperate="batchOperate"/>
            <AgentList ref="agentList" v-show="batchShow" @completeAction="completeAction"/>
          </TabPane>
          <TabPane label="操作日志" name="log">
             <AgentLogs ref="agentLogs" />
          </TabPane>
      </Tabs>
</template>
<script>
import ServerList from './ServerList'
import AgentLogs from './AgentLogs'
import AgentList from './AgentList'
export default {
  name: 'LogAgentServerMain',
  components: {
    AgentLogs,
    ServerList,
    AgentList
  },
  data () {
    return {
      batchShow: false,
      data: {},
      defaultIndex: 'server'
    }
  },
  watch: {
  },
  methods: {
    batchOperate () {
      this.batchShow = true
      console.log(this.$refs.agentList.changeAgent)
      this.$refs.agentList.changeAgent = true
    },
    handleTabClick (value) {
      if (value === 'server') {
        this.$refs.serverList.getServers()
      } else if (value === 'log') {
        this.$refs.agentLogs.getAgentLogList()
      }
    },
    completeAction () {
      this.defaultIndex = 'log'
      handleTabClick('log')
    }
  },
  mounted: function () {
    console.log('LogAgentServerMain mounted')
  }
}
</script>
